import { useMemo } from "react";
import { Button } from "../../uiLibrary/button";
import { useSingleton } from "../../other/injection";
import { RouteStore } from "../../other/navigationAndRouting/RouteStore";
import { LoggedInUserStore } from "../../other/loggedInUser/LoggedInUserStore";
import { observer } from "mobx-react-lite";
import { BigRouteList } from "../../uiLibrary/bigRouteList/BigRouteList";
import styled from "@emotion/styled";
import { BannerPage } from "../../uiLibrary/bannerPage/BannerPage";
import { userRoute } from "../../other/navigationAndRouting/routes";

export const UserPage = observer(() => {
    const loggedInUserStore = useSingleton(LoggedInUserStore);
    const routeStore = useSingleton(RouteStore);

    const routes = routeStore.getChildrenMenuRoutes(userRoute);

    const logout = useMemo(
        () => () => (document.location.href = "/Security/Logout"),
        []
    );

    return (
        <BannerPage title={loggedInUserStore.displayName}>
            <BigRouteList routes={routes} testId="userLinks" />
            <ButtonWrapper>
                <Button buttonType="neutral" testId="logout" onClick={logout}>
                    Logout
                </Button>
            </ButtonWrapper>
        </BannerPage>
    );
});

const ButtonWrapper = styled("div")({
    marginTop: 30
});
